// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table_content__EkWBt {
  margin-top: 70px;
}

.table_buttons__3FKYs {
  margin: 0 auto;
  width: 60%;
  height: 100%;
  display: flex;
  justify-content: space-between;
}

.table_header_button__lwIJv {
  display: none;
}

.table_button__eiaJT {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.table_button_text__e0Ul7 {
  text-transform: none;
  margin-top: 6px;
  color: #FFF8C7;
  font-family: var(--font-rubik);
  font-size: 20px;
  line-height: 24px;
  font-weight: 500;
}
.table_button__eiaJT img {
  width: 60px;
  height: 60px;
}

.table_slide__6\\+KCL {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

@media screen and (max-width: 1300px) {
  .table_header_button__lwIJv {
    display: block;
  }
}
@media screen and (max-width: 768px) {
  .table_header_block__ULPBJ img {
    width: auto !important;
  }
  .table_buttons__3FKYs {
    justify-content: center;
  }
  .table_button__eiaJT {
    margin-right: 20px;
  }
}
@media screen and (max-width: 500px) {
  .table_button__eiaJT {
    margin-right: 12px;
  }
  .table_button_text__e0Ul7 {
    font-size: 14px;
    line-height: 16px;
  }
  .table_button__eiaJT img {
    width: 34px;
    height: 34px;
  }
  .table_content__EkWBt {
    margin-top: 24px;
  }
  .table_header_block__ULPBJ img:nth-child(1) {
    width: 109px;
    height: 36px;
  }
  .table_header_block__ULPBJ img:nth-child(2) {
    width: 134px;
    height: 38px;
  }
}`, "",{"version":3,"sources":["webpack://./src/screens/tamyr/tables/table/table.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,cAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,8BAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AACF;AAAE;EACE,oBAAA;EACA,eAAA;EACA,cAAA;EACA,8BAAA;EACA,eAAA;EACA,iBAAA;EACA,gBAAA;AAEJ;AAAE;EACE,WAAA;EACA,YAAA;AAEJ;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE;IACE,cAAA;EACF;AACF;AAEA;EAEI;IACE,sBAAA;EADJ;EAKA;IACE,uBAAA;EAHF;EAMA;IACE,kBAAA;EAJF;AACF;AAOA;EACE;IACE,kBAAA;EALF;EAME;IACE,eAAA;IACA,iBAAA;EAJJ;EAOE;IACE,WAAA;IACA,YAAA;EALJ;EASA;IACE,gBAAA;EAPF;EAWE;IACE,YAAA;IACA,YAAA;EATJ;EAWE;IACE,YAAA;IACA,YAAA;EATJ;AACF","sourcesContent":[".content {\n  margin-top: 70px;\n}\n\n.buttons {\n  margin: 0 auto;\n  width: 60%;\n  height: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n\n.header_button {\n  display: none;\n}\n\n.button {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  &_text {\n    text-transform: none;\n    margin-top: 6px;\n    color: #FFF8C7;\n    font-family: var(--font-rubik);\n    font-size: 20px;\n    line-height: 24px;\n    font-weight: 500;\n  }\n  img {\n    width: 60px;\n    height: 60px;\n  }\n}\n\n.slide {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n@media screen and (max-width: 1300px) {\n  .header_button {\n    display: block;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .header_block {\n    img {\n      width: auto !important;\n    }\n  }\n\n  .buttons {\n    justify-content: center;\n  }\n\n  .button {\n    margin-right: 20px;\n  }\n}\n\n@media screen and (max-width: 500px) {\n  .button {\n    margin-right: 12px;\n    &_text {\n      font-size: 14px;\n      line-height: 16px;\n    }\n\n    img {\n      width: 34px;\n      height: 34px;\n    }\n  }\n\n  .content {\n    margin-top: 24px;\n  }\n\n  .header_block {\n    img:nth-child(1) {\n      width: 109px;\n      height: 36px;\n    }\n    img:nth-child(2) {\n      width: 134px;\n      height: 38px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `table_content__EkWBt`,
	"buttons": `table_buttons__3FKYs`,
	"header_button": `table_header_button__lwIJv`,
	"button": `table_button__eiaJT`,
	"button_text": `table_button_text__e0Ul7`,
	"slide": `table_slide__6+KCL`,
	"header_block": `table_header_block__ULPBJ`
};
export default ___CSS_LOADER_EXPORT___;
